import { render, staticRenderFns } from "./PostComposer.vue?vue&type=template&id=ffe42250&scoped=true&"
import script from "./PostComposer.vue?vue&type=script&lang=js&"
export * from "./PostComposer.vue?vue&type=script&lang=js&"
import style0 from "./PostComposer.vue?vue&type=style&index=0&id=ffe42250&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffe42250",
  null
  
)

export default component.exports